import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { Spinner } from '@/components/ui/Spinner';
import { useActiveLease } from '@/hooks/useLeases';
import { useContacts } from '@/hooks/useContacts';

export function ContactsPage() {
  const { t } = useTranslation();
  const { activeLease } = useActiveLease();
  const contacts = useContacts(activeLease?.id ?? null);

  if (!activeLease) {
    return (
      <Card title={t('contacts.title')}>
        <p className="text-sm text-slate-600">{t('contacts.no_active_lease')}</p>
      </Card>
    );
  }

  if (contacts.isLoading) return <Spinner />;

  return (
    <Card title={t('contacts.title')}>
      {contacts.data && contacts.data.length > 0 ? (
        <ul className="divide-y divide-slate-100">
          {contacts.data.map((c) => (
            <li key={c.id} className="flex items-center justify-between py-3 text-sm">
              <div>
                <p className="font-medium">{c.name}</p>
                <p className="text-xs text-slate-500">{c.description}</p>
                <Badge tone="info">{t(`contacts.types.${c.type}`)}</Badge>
              </div>
              <a
                href={`tel:${c.phone}`}
                className="rounded-lg bg-brand px-3 py-1.5 text-xs font-medium text-white"
              >
                {c.phone}
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-slate-500">{t('web.empty.no_data')}</p>
      )}
    </Card>
  );
}
